import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import LessonTypesSection from './components/LessonTypesSection';
import ProcessSection from './components/ProcessSection';
import AboutSection from './components/AboutSection';
import CurriculumSection from './components/CurriculumSection';
import PricingSection from './components/PricingSection';
import LocationSection from './components/LocationSection';
import InquirySection from './components/InquirySection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="w-full overflow-x-hidden bg-studio-black">
      <Navbar />

      {/* Hero */}
      <HeroSection />

      {/* Lesson Types */}
      <LessonTypesSection />

      {/* Process */}
      <ProcessSection />

      {/* About / Producer */}
      <AboutSection />

      {/* Curriculum */}
      <CurriculumSection />

      {/* Pricing */}
      <PricingSection />

      {/* Location */}
      <LocationSection />

      {/* Inquiry */}
      <InquirySection />

      <Footer />
    </main>
  );
}